<template>
    <div class="min-h-screen bg-gray-100 p-6">
        <div class="max-w-6xl mx-auto">
            <!-- Header -->
            <div class="bg-white rounded-lg shadow-md p-6 mb-6">
                <div class="flex justify-between items-center">
                    <div>
                        <h1 class="text-3xl font-bold text-gray-800">Gestion des Tables</h1>
                        <p class="text-gray-600">
                            {{ currentRestaurant.name }} - {{ currentServer.name }}
                        </p>
                    </div>
                    <div class="flex space-x-4">
                        <router-link
                                to="/restaurantselector"
                                class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
                        >
                            Changer de restaurant
                        </router-link>
                        <Notifications />
                    </div>
                </div>

                <!-- Cash Register Status -->
                <div class="mt-4 p-4 rounded-lg" :class="cashRegisterStatusClass">
                    <p class="font-semibold">
                        Caisse: {{ currentCashRegister ? currentCashRegister.status : 'N/A' }}
                    </p>
                </div>
            </div>

            <!-- Tables Grid -->
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div
                        v-for="table in currentRestaurantTables"
                        :key="table.id"
                        class="bg-white rounded-lg shadow-md p-6 cursor-pointer transition-transform hover:scale-105"
                        :class="tableStatusClass(table.status)"
                        @click="handleTableClick(table)"
                >
                    <div class="flex justify-between items-center mb-4">
                        <h3 class="text-xl font-semibold">Table {{ table.number }}</h3>
                        <span class="px-3 py-1 rounded-full text-sm font-medium" :class="statusBadgeClass(table.status)">
              {{ table.status === 'free' ? 'Libre' : 'Occupée' }}
            </span>
                    </div>

                    <div v-if="table.status === 'occupied'">
                        <p class="text-gray-600 mb-2">Commandes en cours:</p>
                        <div v-for="order in tableOrders(table.id)" :key="order.id" class="mb-2 p-2 bg-gray-50 rounded">
                            <p class="text-sm">Commande #{{ order.id }}</p>
                            <div class="text-xs text-gray-500">
                <span v-for="item in order.items" :key="item.id" class="mr-2">
                  {{ item.name }} ({{ item.status }})
                </span>
                            </div>
                        </div>
                    </div>

                    <button
                            v-if="table.status === 'occupied'"
                            @click.stop="viewOrderDetails(table)"
                            class="w-full mt-4 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition-colors"
                    >
                        Voir détails
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import Notifications from './notifications.vue';

    export default {
        name: 'ServeurTables',
        components: {
            Notifications
        },
        computed: {
            ...mapState(['currentRestaurant', 'currentServer', 'orders']),
            ...mapGetters(['currentRestaurantTables', 'currentCashRegister', 'currentRestaurantOrders']),
            cashRegisterStatusClass() {
                return this.currentCashRegister?.status === 'open'
                    ? 'bg-green-100 text-green-800'
                    : 'bg-red-100 text-red-800';
            }
        },
        methods: {
            ...mapActions(['updateTableStatus']),
            tableStatusClass(status) {
                return status === 'free' ? 'border-2 border-green-200' : 'border-2 border-orange-200';
            },
            statusBadgeClass(status) {
                return status === 'free'
                    ? 'bg-green-100 text-green-800'
                    : 'bg-orange-100 text-orange-800';
            },
            tableOrders(tableId) {
                return this.currentRestaurantOrders.filter(order => order.tableId === tableId);
            },
            handleTableClick(table) {
                if (table.status === 'free') {
                    if (this.currentCashRegister?.status !== 'open') {
                        alert('La caisse doit être ouverte pour prendre une commande');
                        return;
                    }
                    this.$router.push(`/serveur/commande/${table.id}`);
                } else {
                    this.viewOrderDetails(table);
                }
            },
            viewOrderDetails(table) {
                const order = this.currentRestaurantOrders.find(o => o.tableId === table.id && o.status === 'active');
                if (order) {
                    this.$router.push({ name: 'CommandeDetails', params: { orderId: order.id } });
                }
            }



        }
    };
</script>